var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nx-file-uploader',{ref:"input",attrs:{"extensions":".zip","disabled":_vm.disabled,"selectedFileName":_vm.selectedFileName},on:{"file":_vm.onFileSelected,"dismiss":_vm.dismiss}})}
var staticRenderFns = []

export { render, staticRenderFns }